import React, { useEffect, useState } from 'react';
import {
  Loader2,
  CheckCircle2,
  Send,
  Search,
  BellRing
} from 'lucide-react';

const steps = [
  {
    title: 'Publicando tu solicitud',
    description: 'Estamos preparando los datos de tu solicitud.',
    icon: Send
  },
  {
    title: 'Buscando cuidadores cercanos',
    description: 'Estamos encontrando cuidadores disponibles en tu zona.',
    icon: Search
  },
  {
    title: 'Notificando cuidadores disponibles',
    description: 'Tu solicitud ya está siendo compartida con cuidadores.',
    icon: BellRing
  }
];

export default function UcanMatchStatus({ request, onClose }) {
  const [currentStep, setCurrentStep] = useState(0);
  const [completed, setCompleted] = useState(false);

  useEffect(() => {
    const timers = [
      setTimeout(() => setCurrentStep(1), 1400),
      setTimeout(() => setCurrentStep(2), 3000),
      setTimeout(() => setCompleted(true), 4700),
      setTimeout(() => onClose?.(), 6500)
    ];

    return () => timers.forEach(clearTimeout);
  }, [onClose]);

  return (
    <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden">
      <div className="p-7 md:p-10 text-center">

        {!completed ? (
          <>
            <div className="w-20 h-20 mx-auto rounded-full bg-red-50 flex items-center justify-center mb-6">
              <Loader2 className="w-10 h-10 text-[#E6202E] animate-spin" />
            </div>

            <p className="text-sm font-bold uppercase tracking-wider text-[#E6202E] mb-2">
              U-CAN está trabajando por ti
            </p>

            <h2 className="font-montserrat text-2xl md:text-3xl font-black text-gray-900">
              Estamos buscando la mejor opción
            </h2>

            <p className="text-gray-500 mt-2 max-w-md mx-auto">
              Tu solicitud fue recibida correctamente. Ahora estamos activando la búsqueda de cuidadores.
            </p>

            <div className="mt-8 space-y-3 text-left max-w-lg mx-auto">
              {steps.map((step, index) => {
                const Icon = step.icon;
                const isDone = index < currentStep;
                const isActive = index === currentStep;

                return (
                  <div
                    key={step.title}
                    className={`flex items-center gap-4 p-4 rounded-2xl border transition-all duration-500 ${
                      isActive
                        ? 'border-[#E6202E] bg-red-50 shadow-sm'
                        : isDone
                          ? 'border-green-200 bg-green-50'
                          : 'border-gray-100 bg-gray-50 opacity-50'
                    }`}
                  >
                    <div
                      className={`w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0 ${
                        isDone
                          ? 'bg-green-600 text-white'
                          : isActive
                            ? 'bg-[#E6202E] text-white'
                            : 'bg-gray-200 text-gray-400'
                      }`}
                    >
                      {isDone ? (
                        <CheckCircle2 className="w-6 h-6" />
                      ) : isActive ? (
                        <Loader2 className="w-6 h-6 animate-spin" />
                      ) : (
                        <Icon className="w-5 h-5" />
                      )}
                    </div>

                    <div>
                      <p
                        className={`font-bold ${
                          isDone
                            ? 'text-green-800'
                            : isActive
                              ? 'text-gray-900'
                              : 'text-gray-500'
                        }`}
                      >
                        {step.title}
                      </p>

                      <p className="text-sm text-gray-500 mt-0.5">
                        {step.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        ) : (
          <div className="py-6">
            <div className="w-24 h-24 mx-auto rounded-full bg-green-100 flex items-center justify-center mb-6">
              <CheckCircle2 className="w-14 h-14 text-green-600" />
            </div>

            <p className="text-sm font-bold uppercase tracking-wider text-green-600 mb-2">
              Todo listo
            </p>

            <h2 className="font-montserrat text-3xl md:text-4xl font-black text-gray-900">
              ¡Solicitud enviada!
            </h2>

            <p className="text-gray-600 mt-3 max-w-md mx-auto text-lg">
              Tu solicitud ya está activa. Los cuidadores disponibles podrán verla y enviarte sus propuestas.
            </p>

            {request?.comuna && (
              <div className="inline-flex mt-5 px-4 py-2 rounded-full bg-green-50 text-green-700 font-bold text-sm">
                Buscando cuidadores en {request.comuna}
              </div>
            )}
          </div>
        )}

      </div>
    </div>
  );
}
